import * as React from 'react';
import PropTypes from 'prop-types';
import ExtendedDropDownList from '../../forms/DropDownList';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import Input from '../../forms/Input';
import DateInput from '../../forms/DateInput';
import DateRangeInput from '../../forms/DateRangeInput';
import NumericTextBox from '../../forms/NumericTextBox';
import sk from '../../res/sk.json';
import './DialogFilter.scss';
import _ from 'lodash';
import { fieldFormat } from '../../utils/helper';

const NUMERIC_OPS = [
  { text: sk.grid.filterEqOperator, operator: 'eq' },
  { text: sk.grid.filterNotEqOperator, operator: 'neq' },
  { text: sk.grid.filterGteOperator, operator: 'gte' },
  { text: sk.grid.filterGtOperator, operator: 'gt' },
  { text: sk.grid.filterLteOperator, operator: 'lte' },
  { text: sk.grid.filterLtOperator, operator: 'lt' },
  { text: sk.grid.filterIsNullOperator, operator: 'isnull' },
  { text: sk.grid.filterIsNotNullOperator, operator: 'isnotnull' }
];

const DATE_OPS = [[
  { text: sk.grid.filterEqOperator, operator: 'eq' },
  { text: sk.grid.filterNotEqOperator, operator: 'neq' },
  { text: sk.grid.filterAfterOrEqualOperator, operator: 'gte' },
  { text: sk.grid.filterAfterOperator, operator: 'gt' },
  { text: sk.grid.filterBeforeOperator, operator: 'lt' },
  { text: sk.grid.filterBeforeOrEqualOperator, operator: 'lte' },
  { text: sk.grid.filterIsNullOperator, operator: 'isnull' },
  { text: sk.grid.filterIsNotNullOperator, operator: 'isnotnull' },
  { text: sk.grid.filterBetweenOperator, operator: 'between' },
]];

const FILTER_OPERATORS = {
  text: [
    { text: sk.grid.filterContainsOperator, operator: 'contains' },
    { text: sk.grid.filterNotContainsOperator, operator: 'doesnotcontain' },
    { text: sk.grid.filterEqOperator, operator: 'eq' },
    { text: sk.grid.filterNotEqOperator, operator: 'neq' },
    { text: sk.grid.filterStartsWithOperator, operator: 'startswith' },
    { text: sk.grid.filterEndsWithOperator, operator: 'endswith' },
    { text: sk.grid.filterIsEmptyOperator, operator: 'isempty' },
    { text: sk.grid.filterIsNotEmptyOperator, operator: 'isnotempty' }
  ],
  numeric: NUMERIC_OPS,
  unitnumeric: NUMERIC_OPS,
  date: DATE_OPS,
  dateinput: DATE_OPS,
  datetime: DATE_OPS,
  datetimeinput: DATE_OPS,
  boolean: [
    { text: sk.grid.filterBooleanAll, operator: '' },
    { text: sk.grid.filterIsTrue, operator: true },
    { text: sk.grid.filterIsFalse, operator: false }
  ],
  container: [
    { text: sk.grid.filterContainsOperator, operator: 'contains' },
    { text: sk.grid.filterNotContainsOperator, operator: 'doesnotcontain' },
    { text: sk.grid.filterEqOperator, operator: 'eq' },
    { text: sk.grid.filterNotEqOperator, operator: 'neq' },
    { text: sk.grid.filterStartsWithOperator, operator: 'startswith' },
    { text: sk.grid.filterEndsWithOperator, operator: 'endswith' },
    { text: sk.grid.filterIsEmptyOperator, operator: 'isempty' },
    { text: sk.grid.filterIsNotEmptyOperator, operator: 'isnotempty' }
  ]
};


/**
 * Dialog fiter form component
 * @module
 * @param {array} schema - Schema
 * @param {object} [parentProps] - Parent props
 * @param {object} filter - Filter 
 * @param {string} enumDefault - Enum default value
 */
class DialogFilterForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      input: {}
    }

    this.ref = React.createRef();
  }

  createInput = () => {
    let input = {};
    this.props.filter.filters.forEach(item => {
      input[item.field + 'Operator'] = item.operator;
      input[item.field + 'Value'] = item.value;
    });
    this.setState({ input });
  }

  componentDidMount() {
    this.createInput();
  }

  componentDidUpdate(prevProps) {
    if (this.props.filter !== prevProps.filter) {
      this.createInput();
    }
  }

  handleChange = (name, value) => {
    this.setState(prevState => ({
      input: {
        ...prevState.input,
        [name]: value ? (value.text ? value.operator : value) : null
      }
    }));
  }

  operatorSK = (item) => {
    let value;
    if (item.filter === 'boolean') {
      value = this.state.input[item.field + 'Value'] === false ? false : (this.state.input[item.field + 'Value'] ? true : null)
    }
    else {
      value = this.state.input[item.field + (item.filter === "container" ? "." + item.textField : "") + 'Operator'] || null
    }
    const operator = FILTER_OPERATORS[item.filter && item.filter !== "none" ? item.filter : 'text'];
    return operator ? operator.find(item => item.operator === value) : undefined;
  }

  hasValue = (value) => {
    return value && value !== this.props.enumDefault;
  }

  render() {
    return (
      <div ref={this.ref} className="k-form-inline dialogFilter">
        {_.sortBy(this.props.schema, 'OrderFilter').map(item => {
          if (item.Filterable === false)
            return null;

          const value = this.state.input[item.field + 'Value'] || null;
          const operator = this.state.input[item.field + 'Operator'];
          switch (item.filter) {

            case "cmd":
              return null;
            case "enum":
              const primaryField = item.primaryField;
              const enumValue = primaryField ? this.props.parentProps[item.dataField].find(el => el[primaryField] === Number(this.state.input[item.field + 'Value'])) : this.state.input[item.field + 'Value']
              return (
                <div className="k-form-field" key={item.field}>
                  <span className="title">{item.FilterTitle || item.title}</span>
                  <div>
                    <DropDownList
                      data={this.props.parentProps[item.dataField]}
                      onChange={(event) => {
                        const hasValue = this.hasValue(event.target.value);
                        this.handleChange(
                          item.field + 'Value',
                          hasValue ? (primaryField ? event.target.value[primaryField] : event.target.value) : '',
                        );
                      }}
                      value={enumValue || this.props.enumDefault}
                      defaultItem={this.props.enumDefault}
                      textField={item.textField}
                    />
                  </div>
                </div>
              )
            case "boolean":
              return (
                <div className="k-form-field" key={item.field}>
                  <span className="title">{item.FilterTitle || item.title}</span>
                  <div>
                    <ExtendedDropDownList
                      name={item.field + 'Value'}
                      data={FILTER_OPERATORS["boolean"]}
                      textField="text"
                      onChange={this.handleChange}
                      value={this.operatorSK(item)}
                    />
                  </div>
                </div>
              )

            case "date":
            case "dateinput":
            case "datetime":
            case "datetimeinput":

              return (
                <div className="k-form-field" key={item.field}>
                  <span className="title">{item.FilterTitle || item.title}</span>
                  <div>
                    <ExtendedDropDownList
                      name={item.field + 'Operator'}
                      data={FILTER_OPERATORS[item.filter]}
                      textField="text"
                      onChange={this.handleChange}
                      value={this.operatorSK(item)}
                    />
                  </div>
                  {operator === 'between' &&
                    <DateRangeInput
                      name={item.field + 'Value'}
                      onChange={this.handleChange}
                      value={value}
                      calendarSettings={{
                        bottomView: 'month',
                        topView: 'year',
                        views: 3
                      }}
                      format={{
                        year: "numeric",
                        month: "short",
                        day: "numeric"
                      }}
                    />}
                  {operator !== 'between' &&
                    <DateInput
                      name={item.field + 'Value'}
                      onChange={this.handleChange}
                      value={value instanceof Date ? value : null}
                      type={item.filter.replace("input", "")}
                      validationMessage={" "}
                    />}
                </div>
              )
            case "unitnumeric":
            case "numeric":
              return (
                <div className="k-form-field" key={item.field}>
                  <span className="title">{item.FilterTitle || item.title}</span>
                  <div>
                    <ExtendedDropDownList
                      name={item.field + 'Operator'}
                      data={FILTER_OPERATORS[item.filter]}
                      textField="text"
                      onChange={this.handleChange}
                      value={this.operatorSK(item)}
                    />
                  </div>
                  <NumericTextBox
                    name={item.field + 'Value'}
                    onChange={this.handleChange}
                    value={value}
                    format={fieldFormat(item.format)}
                  />
                </div>
              )

            case "container":
              return (
                <div className="k-form-field" key={item.field}>
                  <span className="title">{item.FilterTitle || item.title}</span>
                  <div>
                    <ExtendedDropDownList
                      name={item.field + '.' + item.textField + 'Operator'}
                      data={FILTER_OPERATORS["container"]}
                      textField="text"
                      onChange={this.handleChange}
                      value={this.operatorSK(item)}
                    />
                  </div>
                  <Input
                    name={item.field + '.' + item.textField + 'Value'}
                    onChange={this.handleChange}
                    value={this.state.input[item.field + '.' + item.textField + 'Value'] || ""}
                  />
                </div>
              )

            default:
              return (
                <div className="k-form-field" key={item.field}>
                  <span className="title">{item.FilterTitle || item.title}</span>
                  <div>
                    <ExtendedDropDownList
                      name={item.field + 'Operator'}
                      data={FILTER_OPERATORS["text"]}
                      textField="text"
                      onChange={this.handleChange}
                      value={this.operatorSK(item)}
                    />
                  </div>
                  <Input
                    name={item.field + 'Value'}
                    onChange={this.handleChange}
                    value={this.state.input[item.field + 'Value'] || ""}
                  />
                </div>
              )
          }
        })}
      </div>
    );
  }
}


DialogFilterForm.propTypes = {
  schema: PropTypes.array.isRequired,
  parentProps: PropTypes.object,
  filter: PropTypes.object.isRequired,
  enumDefault: PropTypes.string.isRequired
}

export default DialogFilterForm;